<!-- <app-filters *ngIf="modelData && utils.screenSizeObj.width <768 && modelData.isFilterSection" [filterData]="filterData"
    (modelClose)="onClose($event)">
</app-filters>

<app-otp [otp_number]='modelData.phone' *ngIf="modelData && modelData.isOtpSection" (submitOtp)="onSubmitOtp($event)"
    [responseData]='modelData.responseData' [pageName]='modelData.pageName' (cancelVerify)="dialogRef.close(false)">
</app-otp>

<app-add-new-address *ngIf="modelData && modelData.isAddressSection" [isOrderFlow]="true"
    (closePopUp)="dialogRef.close(false)" (back)="dialogRef.close(true)"
    [addressData]="modelData.selectedAddressToEdit">
</app-add-new-address> -->

<!-- <app-load-calculator   *ngIf="modelData && modelData.isLoadCalculatorSection"
    [loadCalculatorData]="modelData.loadCaluculatorData" [isLoadCalculateOnly]="true">
</app-load-calculator> -->


<ng-container *ngIf="utils.screenSizeObj.width < 768 && modelData?.length == 0; else loadingCookieContent">

    <p class="placeholder-glow">
        <span class="placeholder col-12 w-100"></span>
    </p>
</ng-container>
<ng-template #loadingCookieContent>

    <div class="cookiesData" *ngIf="modelData && modelData.cookiesSection">
        <div class="content">
            <img width="38" height="38" [src]="environment?.blobUrl+'/assets/icons/cookie.svg'"
                alt="Cookie Image | Luminous">
            <div class="text">
                <p id="cookiesModelTitle" class="fw-bold fs-4">Cookies Privacy</p>
                <p id="cookiesModelDescription" class="ps-3 fs-5">This website uses cookies that help the website
                    function and to help us understand how to interact with it. We use these cookies to provide you with
                    improved and customized user experience. If you continue to use the website, we assume that you are
                    okay with it.</p>
            </div>
        </div>
        <button (click)="dialogRef.close(true)" class="primaryBtn">Got It</button>
    </div>
</ng-template>
<div class="confirmationModal" *ngIf="modelData && modelData.isConfirmation">
    <div class="head">
        <h2 mat-dialog-title class="title">{{data.title}}</h2>
        <div class="crossbtn" (click)="dialogRef.close(false)">
            <img loading="lazy" [src]="environment?.blobUrl+'/assets/icons/close.svg'" alt="Close Icon | Luminous" />
        </div>
    </div>
    <div class="message" mat-dialog-content>
        {{data.content}}
    </div>

    <div class="text-end btnContainer">
        <button class="greyBtn" (click)="dialogRef.close(false)">{{data.closeBtnText}}</button>
        <button *ngIf="data.confirmBtnText" class="redBtn"
            (click)="dialogRef.close(true)">{{data.confirmBtnText}}</button>
    </div>
</div>
<div class="confirmationModal" *ngIf="modelData && modelData.isCartChange">
    <div class="head">
        <h2 mat-dialog-title class="title">{{data.title}}</h2>
        <div class="crossbtn" (click)="dialogRef.close(true)">
            <img loading="lazy" [src]="environment?.blobUrl+'/assets/icons/close.svg'" alt="Close Icon | Luminous" />
        </div>
    </div>
    <div class="message" mat-dialog-content>
        {{data.content}}
    </div>
    <div class="text-end btnContainer">
        <button class="greyBtn" (click)="dialogRef.close(false)">{{data.closeBtnText}}</button>
        <button *ngIf="data.confirmBtnText" class="redBtn"
            (click)="dialogRef.close(true)">{{data.confirmBtnText}}</button>
    </div>
</div>